/** @format */

const template = `
<sis-popover
  (hidden)="$ctrl.onHidden()"
  [is-open]="$ctrl.popoverIsOpen"
  [popover-placement]="$ctrl.filterPlacement"
  [show-close-button]="false"
  (shown)="$ctrl.onShown()"
  [trigger-text]="$ctrl.filterName"
  [underline-trigger-text]="false"
  [dropdown-item]="true"
  data-cy="search-filter-menu-item"
  (click)="$ctrl.clickTrigger()">
  <search-filter
    class="sis-popover-popover-content"
    on-select="$ctrl.submitFilter(values)"
    option="$ctrl.option"
    parameter-model="$ctrl.parameterModel"
    popover-is-open="$ctrl.popoverIsOpen"
    search-again="$ctrl.searchAgain()"
    search-params="$ctrl.searchParams"
    university="$ctrl.university"></search-filter>
</sis-popover>
`;
export default template;
